module.exports = __webpack_public_path__ + "img/searchicon.dfd1299c.svg";